export const EmailValidationRule = {
  status: true,
  field: 'email',
  validators: [
    {
      code: 'CustomValidators.regExp',
      name: 'RegExp',
      input: true,
      input_value: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}$'
    }
  ],
  conditions: [],
  name: 'Email'
};



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/ParentClass/additional-rules.ts